import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export function XpChip({ user }) {
  return (
    <Link
      to="/ranks"
      data-testid="xp-chip"
      className="flex items-center gap-1.5 h-10 px-3.5 rounded-full border border-[#E50914]/50 bg-[#E50914]/10 hover:bg-[#E50914]/20 transition-colors"
    >
      <Zap size={16} className="text-[#E50914] fill-[#E50914]" />
      <span className="font-display text-lg font-semibold leading-none" data-testid="xp-chip-value">{user.xp}</span>
      <span className="text-[10px] font-bold uppercase tracking-wider text-[#A1A1AA]">Lv {user.level}</span>
    </Link>
  );
}

export function LevelBar({ user, className = "" }) {
  const span = user.next_at ? user.next_at - user.floor : 1;
  const pct = user.next_at ? Math.min(100, Math.round(((user.xp - user.floor) / span) * 100)) : 100;
  return (
    <div className={className} data-testid="level-bar">
      <div className="flex items-end justify-between mb-2">
        <div>
          <div className="eyebrow mb-1">Your level</div>
          <div className="font-display text-2xl font-semibold uppercase tracking-tight leading-none" data-testid="level-title">Level {user.level}</div>
        </div>
        <div className="text-right">
          <div className="font-display text-2xl font-semibold leading-none" data-testid="level-xp">{user.xp} <span className="text-sm text-[#71717A]">XP</span></div>
        </div>
      </div>
      <div className="h-2 rounded-full bg-[#222225] overflow-hidden">
        <div className="h-full rounded-full bg-[#E50914] transition-[width] duration-700" style={{ width: `${pct}%` }} />
      </div>
      <div className="text-xs text-[#71717A] mt-2" data-testid="level-next">
        {user.next_at ? <>{user.next_at - user.xp} XP to Level {user.level + 1}</> : "Max level reached"}
      </div>
    </div>
  );
}
